import React, { useState, useEffect, Fragment } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import Header from "../components/headerNA";
import Footer from "../components/footer";
import { obtenerScore, getDocuments, finalUpdateScore } from '../services/api.js'
import { configStyle, obtenerValorConfig } from '../services/configStyle'
import Loader from "../components/loader";
import { isMobile, isIOS } from 'react-device-detect';
import { hayExcepcion, status, statusError, statusData, regresarJson, sendData, evento } from '../services/data';
import Ayuda from './ayuda';

let ConsultaHistorial = (props) => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [statError, setstatError] = useState(false);
    const [apiKey, setApiKey] = useState('')
    const [uuid, setUuid] = useState('-')
    const [dataUser, setDataUser] = React.useState([])
    const [dataOtorgante, setDataOtorgante] = useState([])
    const [dataFace, setDataFace] = useState({})
    const [correo, setCorreo] = useState('')
    const [correoMsj, setCorreoMsj] = useState(false)
    const [focusCorreo, setFocusCorreo] = useState(false)
    const [isFlag, setFlag] = useState('RED')
    const { ruta } = useParams();
    const [showHelp, setShowHelp] = useState(false);
    const [contador, setContador] = useState(0)
    const [flag] = useState(false);
    const intentos = 15;
    const [finished, setFinished] = useState(false);
    const [uuidTrx, setUuidTrx] = useState('-');

    useEffect(() => {
        let apikeyOtorgante = localStorage.getItem("apikeyOtorgante")
        if (apikeyOtorgante !== null) {
            setApiKey(apikeyOtorgante)
        }
        let uuidUser = localStorage.getItem("uuidUser")
        if (uuidUser != null) {
            setUuid(uuidUser)
        }
        let uuidTransaccion = localStorage.getItem("uuidTrx");
        if (uuidTransaccion) {
            setUuidTrx(uuidTransaccion)
        }
        let dataUserLS = localStorage.getItem("data_user")
        if (dataUserLS != null) {
            setDataUser(JSON.parse(dataUserLS))
        }
        let dataOtorganteLS = localStorage.getItem("dataOtorgante")
        if (dataOtorganteLS != null) {
            setDataOtorgante(JSON.parse(dataOtorganteLS))
        }
        let dataFaceLS = localStorage.getItem("face")
        if (dataFaceLS != null) {
            setDataFace(JSON.parse(dataFaceLS))
        }

        actualizarScore()
        status("consulta_score_page", "Validación de Score")

    }, [])

    useEffect(() => {
        localStorage.setItem("data_user", JSON.stringify(dataUser))
    }, [dataUser])

    useEffect(() => {
        configStyle(dataOtorgante)
    }, [dataOtorgante])

    useEffect(() => {
        //console.log("contador", contador);
        setTimeout(() => {
            if (!flag && parseInt(contador) < intentos && parseInt(contador) > 0) {
                obtenerScoreUser()
            } else {
                if (parseInt(contador) > intentos) {
                    console.log("sin dato en bandera");
                    statusError("score_check", "Sin valores en el score", "error")
                }
                setLoading(false)
            }
        }, 200);

    }, [contador])

    const obtenerScoreUser = async () => {
        let tipo = '';
        let informacion = {};
        setLoading(true)
        let uuidUser = localStorage.getItem("uuidUser")
        //console.log("entre a obtener");
        obtenerScore(uuidUser, !isMobile).then((response) => {
            //console.log("Response200",response);
            if (response.status === 200) {
                //console.log("200:", response.data.payload);
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Obtener Score', 'Success', informacion, true);
                if (response.data.payload.flag) {
                    let data = { flag: response.data.payload.flag }
                    statusData("consulta_score", data)
                    let b = (response.data.payload.flag).toUpperCase()
                    setFlag(b);
                    let campos = JSON.stringify(response.data.payload.Fields)
                    localStorage.setItem("fields", campos);
                    localStorage.setItem("flag", response.data.payload.flag);
                } else {
                    console.log("sin bandera");
                    setContador(parseInt(contador) + 1)
                }
                setTimeout(() => {
                    dataLinks();
                }, 300);
            }
        }).catch((error) => {
            setContador(parseInt(contador) + 1);
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Score', tipo, informacion, false);
        })
    }

    const convertdataJSON = () => {
        var fecha = ""
        let date = new Date()
        let day = date.getDate()
        let month = date.getMonth() + 1
        let year = date.getFullYear()
        if (month < 10) {
            fecha = `${day}0${month}${year}`
        } else {
            fecha = `${day}${month}${year}`
        }
        var jsonObj = {};
        let uuid = localStorage.getItem("uuidUser");
        let uuidTrx = localStorage.getItem("uuidTrx");
        let dataOtorgante = JSON.parse(localStorage.getItem("dataOtorgante"));
        jsonObj.uuidUser = uuid;
        jsonObj.uuidTrx = uuidTrx;
        let partner = obtenerValorConfig(dataOtorgante, "PARTNER", "")
        partner = partner.replace(" ", "_");
        if (partner !== "") {
            partner = partner + "_"
        }
        let name_otorgante = obtenerValorConfig(dataOtorgante, "NOMBRE_CORTO", "")
        name_otorgante = name_otorgante.replace(" ", "_");
        let uuidC = partner + name_otorgante + "_" + fecha + "_" + uuid.split("-")[0];
        jsonObj.custom_uuid = uuidC;
        jsonObj.ocrBack = JSON.parse(localStorage.getItem("ocrBack"));
        jsonObj.ocrFront = JSON.parse(localStorage.getItem("ocrFront"));
        jsonObj.data_user = JSON.parse(localStorage.getItem("data_user"));
        jsonObj.links = JSON.parse(localStorage.getItem('links')) || "";
        return jsonObj;
    }

    const dataLinks = async () => {
        //console.log(event_t);
        let tipo = '';
        let informacion = {};
        getDocuments().then((response) => {
            informacion.status = response.status;
            informacion.payload = response.data.payload;
            evento('Obtener Documentos', 'Success', informacion, true);
            if (response.status === 200) {
                if (response.data.payload.links) {
                    let asd = JSON.stringify(response.data.payload.links)
                    localStorage.setItem('links', asd);
                }
            }
            setTimeout(() => {
                updateStatus();
            }, 300);
        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Obtener Documentos', tipo, informacion, false);
            setTimeout(() => {
                updateStatus();
            }, 300);
        })
    }

    const updateStatus = async () => {
        let res = convertdataJSON();
        let event_t = JSON.stringify(res)
        var json_final = {};
        let statu = "OK"
        if (isFlag === "YELLOW") {
            statu = "FAIL"
        }
        json_final = {
            "status": statu,
            "step": "finished",
            "description": event_t,
            "finished": true
        }
        let event = JSON.stringify(json_final);
        await sendData({ 'step': 'finalizado', 'event': event });
        localStorage.setItem("completado", "true");
        setFinished(true);
        statusFinal();
    }

    const statusFinal = () => {
        setTimeout(() => {
            setLoading(false)
        }, 2000);
        if (window.opener) {
            let uuidTrx = localStorage.getItem("uuidTrx");
            let event_t = "OK"

            if (regresarJson()) {
                let res = convertdataJSON();
                event_t = (res !== "") ? JSON.stringify(res) : ""
            }
            //console.log("entre a status finish", uuidUser);
            window.opener.postMessage(JSON.stringify({
                step: "completed",
                result: event_t,
                uuid: uuidTrx,
            }), localStorage.getItem("externalReference"))
            setTimeout(() => {
                window.close();
            }, 1500);
        }
    }

    const actualizarScore = () =>{
        let tipo = '';
        let informacion = {};
        setLoading(true);
        let objeto = { createScore: true}
        finalUpdateScore(objeto).then((response) => {
            if (response.status === 200) {
                informacion.status = response.status;
                informacion.payload = response.data.payload;
                evento('Actualizar Score', 'Success', informacion, true);
                setTimeout(() => {
                    obtenerScoreUser();
                }, 300);
            }
        }).catch((error) => {
            if (error.response) {
                let { data: { message }, status } = error.response
                informacion.mensaje = message;
                informacion.status = status;
                tipo = 'Error';
            } else {
                informacion.error = error.toString();
                tipo = 'Exception';
            }
            evento('Actualizar Score', tipo, informacion, false);
        })
    }

    return (
        <div className="main_gradient">
            <Header ruta="finalizado" show={() => setShowHelp(true)} />
            <div className="main_text_container">
                {
                    (isFlag !== "RED") ?
                        <h1 className="animate__animated animate__fadeIn animate__delay-1s">¡Muchas gracias!</h1>
                        :
                        <h1 className="animate__animated animate__fadeIn animate__delay-1s">Proceso no exitoso</h1>
                }
                {
                    (isFlag === "GREEN") ?
                        <div className="animate__animated animate__fadeIn animate__delay-2s">
                            <p>Has completado tu validación exitosamente. </p>

                        </div>
                        :
                        (isFlag === "YELLOW") ?
                            <div className="animate__animated animate__fadeIn animate__delay-2s">
                                <p>Tu validación no fue completada exitosamente, por favor inténtalo de nuevo más tarde.</p>
                                <br />

                            </div>
                            :
                            <div className="animate__animated animate__fadeIn animate__delay-2s">
                                <p>Lo sentimos tu validación <b>no fue aceptado</b>, te sugerimos <b>verificar tu documentación</b> e intentarlo mas adelante siguiendo <b>detenidamente las instrucciones</b>.</p>
                                <br />

                            </div>

                }
            </div>
            <p className="text-center" >Folio: <br />
                <b>{uuidTrx.split("-")[0]}</b>
            </p>
            {
                    (!window.opener) &&
                    <div className="action_buttons">
                        <button type="button" onClick={(e) => {
                            evento('Validación de Score', 'Click', { description: 'TERMINAR' }, true);
                            setTimeout(() => {
                                history.push('/' + apiKey)
                            }, 300);
                        }} className="btn btn-raised btn-primary forcewidth100 main_bg_color" disabled={!finished}>TERMINAR</button>
                    </div>
            }
            {/*
                (isFlag !== "RED") ?
                    <div className="main_icon_container animate__animated animate__fadeIn animate__delay-2s">
                        <br />
                        <a id="linkApp" href={"" + localStorage.getItem("package") + "://folio=" + localStorage.getItem("uuidUser")}>
                            {((isFlag === "YELLOW") ? <img src={process.env.PUBLIC_URL + 'images/check_warning.svg'} alt="" /> : <img src={(obtenerValorConfig(dataOtorgante, 'ICONO_ID_CHECK', "") != "") ? obtenerValorConfig(dataOtorgante, 'ICONO_ID_CHECK', process.env.PUBLIC_URL + '/images/check.svg') : process.env.PUBLIC_URL + '/images/check.svg'} alt="" />)}
                        </a>
                        <br /><br />
                        <p className="text-center" >Folio: <br />
                            <b>{uuid.split("-")[0]}</b>
                        </p>
                        {
                            (localStorage.getItem("package") !== null) ?
                                <div className="action_buttons">
                                    <a className="btn btn-raised btn-primary forcewidth100 main_bg_color animate__animated animate__delay-3s" href={"" + localStorage.getItem("package") + "://folio=" + localStorage.getItem("uuidUser")}>
                                        Volver al origen
                                    </a>
                                </div>
                                :
                                (!window.opener) &&
                                <div className="action_buttons">
                                    <button type="button" onClick={(e) => history.push('/'+ apiKey)} className="btn btn-raised btn-primary forcewidth100 main_bg_color">TERMINAR</button>
                                </div>
                        }
                    </div>
                    :
                    <div className="main_text_container animate__animated animate__fadeIn animate__delay-2s" style={{ padding: "0 10%" }}>
                        <div className="help_container">
                            <p className="help_mail"><b>Escríbenos a:</b>
                                <br />
                                <span className="d-flex align-items-center">
                                    <i className="arroba"></i><a href={"mailto:" + obtenerValorConfig(dataOtorgante, 'EMAIL_CONTACTO_PRINCIPAL')}>{obtenerValorConfig(dataOtorgante, "EMAIL_CONTACTO_PRINCIPAL")}</a>
                                </span>
                            </p>
                            <p className="help_phone"><b>Llámanos al:</b>
                                <br />
                                <span className="d-flex align-items-center">
                                    <i className="phone"></i><a href={"tel:" + obtenerValorConfig(dataOtorgante, 'TEL_CONTACTO_PRINCIPAL')}>{obtenerValorConfig(dataOtorgante, 'TEL_CONTACTO_PRINCIPAL')}</a>
                                </span>
                            </p>
                            <p className="help_whats"><b>Hablemos en:</b>
                                <br />
                                <span className="d-flex align-items-center">
                                    <i className="whatsapp"></i><a rel="external" href={"https://wa.me/" + obtenerValorConfig(dataOtorgante, 'TEL_CONTACTO_PRINCIPAL') + "?text=Tuve%20problemas%20en%20el%20proceso%20mi%20ID%20de%20transacci%C3%B3n%20es%20%20" + uuid.split("-")[0]}>WhatsApp</a>
                                </span>
                            </p>
                        </div>
                    </div>
                    */}
            {(loading) && <Loader />}

            <Footer />
            {showHelp ? <Ayuda hide={() => setShowHelp(false)} /> : ""}
        </div>
    )
}

export default ConsultaHistorial